import axios from 'axios';
import {
	ENDPOINT_URL,
	HOME_DASHBOARD_STATS_API,
} from '../../../constants/commonConstants';
import {decodeAgentResponse} from '../../core/resolutionUtils';

/**
 * Read a whole number from an API value.
 * @param {*} value API value
 * @return {number} count
 */
function count(value) {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * Report how many Sites there are.
 *
 * Nested one level in the payload - group_count.group_count - which is what
 * the Home Dashboard header reads for the figure beside "Sites". Always the
 * global total: asked from inside a Site, the answer people expect is still
 * the number they can see on Home, not that site's sub-groups.
 *
 * @return {Promise<{values: {total: number}}>} count
 */
export async function readSiteCounts() {
	const {data} = await axios.get(`${ENDPOINT_URL}${HOME_DASHBOARD_STATS_API}`);
	const document = decodeAgentResponse(data) || {};
	const stats = document?.data ?? document;
	return {values: {total: count(stats?.group_count?.group_count)}};
}
